import React from 'react';

import { checkCircle, checkCircleEmpty } from '@/assets/icons';
import { classNames } from '@/helpers/classNames';
import { CircularProgress, SvgIcon } from '@material-ui/core';

import styles from './ItemsList.module.scss';

type ItemsListProps = {
	className?: string;
	items: {
		checked?: boolean;
		label: string;
	}[];
};

export const ItemsList: React.FC<ItemsListProps> = ({ className, items }) => {
	const classes = classNames([styles['root'], className]);

	return (
		<div className={classes}>
			{items.map(({ checked = true, label }, index) => (
				<div key={`list-item-${index}`}>
					{checked ? (
						<SvgIcon
							className={styles['svg']}
							viewBox="0 0 20 20"
							component={checkCircle}
						/>
					) : (
						<CircularProgress size={20} color="primary" />
					)}
					<div>{label}</div>
				</div>
			))}
		</div>
	);
};
